import { FilledSelectStyle } from './filled-select-style'

export default FilledSelectStyle
